import { render, staticRenderFns } from "./collapsible.component.vue?vue&type=template&id=6c2b31b1&scoped=true&"
import script from "./collapsible.component.vue?vue&type=script&lang=js&"
export * from "./collapsible.component.vue?vue&type=script&lang=js&"
import style0 from "./collapsible.component.vue?vue&type=style&index=0&id=6c2b31b1&lang=scss&scoped=true&"
import style1 from "./collapsible.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b31b1",
  null
  
)

export default component.exports